import React, { useState, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { ListGroup, ListGroupItem } from "components/bootstrap";
import BootstrapModalForm from "components/bootstrap/BootstrapModalForm";
import Input from "components/bootstrap/Input";
import QueryTitle from "views/logic/queries/QueryTitle";
import useQueryIds from "views/hooks/useQueryIds";
import useActiveQueryId from "views/hooks/useActiveQueryId";
const _tabList = (view, queryIds) => queryIds.map((queryId) => {
  const tabTitle = QueryTitle(view, queryId) || "Unknown Page title";
  return { id: queryId, name: tabTitle };
});
const MoveWidgetToTabModal = ({ view, onCancel, onSubmit, widgetId }) => {
  const { t } = useTranslation("widgets");
  const [selectedTab, setSelectedTab] = useState(null);
  const [keepCopy, setKeepCopy] = useState(false);
  const activeQuery = useActiveQueryId();
  const queryIds = useQueryIds();
  const onKeepCopy = useCallback((e) => setKeepCopy(e.target.checked), [setKeepCopy]);
  const submit = useCallback(
    () => onSubmit(widgetId, selectedTab, keepCopy),
    [onSubmit, widgetId, selectedTab, keepCopy]
  );
  const list = _tabList(view, queryIds.toArray()).filter(({ id }) => id !== activeQuery);
  const tabList = list.map(({ id, name }) => /* @__PURE__ */ React.createElement(ListGroupItem, { onClick: () => setSelectedTab(id), active: id === selectedTab, key: id }, name));
  const renderResult = list && list.length > 0 ? /* @__PURE__ */ React.createElement(ListGroup, null, tabList) : /* @__PURE__ */ React.createElement("span", null, t("move_widget.no_pages"));
  return /* @__PURE__ */ React.createElement(
    BootstrapModalForm,
    {
      show: true,
      onCancel,
      submitButtonDisabled: !selectedTab,
      submitButtonText: keepCopy ? t("move_widget.copy") : t("move_widget.move"),
      onSubmitForm: submit,
      title: t("move_widget.title")
    },
    renderResult,
    /* @__PURE__ */ React.createElement(
      Input,
      {
        type: "checkbox",
        id: "keepCopy",
        name: "keepCopy",
        label: t("move_widget.keep_copy"),
        onChange: onKeepCopy,
        help: t("move_widget.keep_copy_help"),
        checked: keepCopy
      }
    )
  );
};
export default MoveWidgetToTabModal;
